export default __webpack_public_path__ + "7f832aa66b398b8c3a31680d2dc8d5bd.png";